import api from "@api";

export default {
    state: {
        menues: [],
        menuDto: {
            language:'',
            files:""
        },
        changeOrderDto:{
            id:'',
            newOrder:'',
            language:''
        },
        langOptions: [
            { id: '1', name: " العربية" },
            { id: '2', name: "الإنكليزية" },
            { id: '3', name: " الكوردي" }
        ],
    },
    mutations: {
        SET_MENU(state, payload) {
            console.log('test', payload)
            state.menues = payload;
        },
        Add_Menu(state, payload) {
            state.menues = payload
        },
        Update_Order(state, payload) {
            state.changeOrderDto = payload
        },
        Reset_Order_Dto(state) {
            state.changeOrderDto = {
                id: "",
                newOrder: "",
                language:''
            };
        },
        Delete_Img(state, id) {
            state.menues.splice(
                state.menues.findIndex((item) => item.id == id),
                1
            );
        },
    },
    actions: {
        getAllMenuAr({ commit }) {
            api.get('Image/GetAll?language=1', ({ data }) => {
                commit("SET_MENU", data);
            });
        },
        getAllMenuEn({ commit }) {
            api.get('Image/GetAll?language=2', ({ data }) => {
                commit("SET_MENU", data);
            });
        },
        getAllMenuKr({ commit }) {
            api.get('Image/GetAll?language=3', ({ data }) => {
                commit("SET_MENU", data);
            });
        },
        addMenu({ commit }, payload) {
            api.form.post(
                "Image/Add",
                payload,
                ({ data }) => {
                    commit("Add_Menu", data);
                },
                {
                    success: "تم إضافة الصورة بنجاح",
                    error: "فشلت الإضافة "
                }
            );
        },
        changeOrder({ commit }, payload) {
            api.post(
                "Image/ChangeOrder",
                payload,
                ({ data }) => {
                    commit("Update_Order", data);
                    commit('SET_MENU', data);
                    commit('Reset_Order_Dto',data)
                },
                {
                    success: "تم تعديل الصور بنجاح",
                    error: "فشل تعديل الصور",
                }
            );
        },
        deleteImg({ commit }, id) {
            api.delete(
                `Image/Delete?id=${id}`,
                () => {
                    commit("Delete_Img", id);
                },
                {
                    confirm: " هل تريد بالتأكيد حذف الصورة",
                    success: "تم حذف الصورة بنجاح",
                    error: "فشل حذف الصورة ..يرجى اعادة المحاولة ",
                }
            );
        },
    }
};
